import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LinkedInSidebar from './LinkedInSidebar';
import { Search, Loader } from "lucide-react";
import axios from "axios";


const SearchPage = ({ 
  setSelectedStock, 
  setCurrentPage, 
  currentPage,
  setTitleDescription,
  openCompanyPage
}) => {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchResults, setsearchResults] = useState([]);
  const [debouncedValue, setDebouncedValue] = useState("");

  useEffect(() => {
    setTitleDescription("Fractofolio - Search Company", "The future of investment networking! Discover market insights, and make informed investment decisions with our community.")
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      if(text.length > 0) {
        setLoading(true);
        setsearchResults([]);
        setDebouncedValue(text);
      }
    }, 2000);

    return () => clearTimeout(handler);
  }, [text]);

  useEffect(() => {
    if(text.length > 0) {
      setLoading(true);
      setsearchResults([]);
    } else {
      setLoading(false);
      setsearchResults([]);
    }
  }, [text]);

  useEffect(() => {
    if (debouncedValue) {
      sendPostRequest(debouncedValue);
    }
  }, [debouncedValue]);

  const sendPostRequest = async (search_request) => {
    if(search_request.length == 0) {
      setLoading(false);
      setsearchResults([]);
      return ""
    }

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/search-companies`, { search_request: search_request });
      if(response.data.status == 'ok') {
        setsearchResults(response.data.result)
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="linkedin-layout bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block lg:col-span-1">
            <LinkedInSidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
          
          <div className="lg:col-span-3">
            <div className="linkedin-card mb-6">
              <div className="linkedin-card-header">
                <h2 className="text-xl font-bold text-gray-900">Search Companies</h2>
                <p className="text-gray-600">Find and analyze any stock market company</p>
              </div>
              
              <div className="linkedin-card-content">
                <div className="flex flex-col md:flex-row gap-4 mb-6">
                  <div className="flex-1">

                    <div className="w-full mx-auto flex items-center justify-between border border-gray-300 rounded-lg focus:border-transparent">
                      <div className="w-full flex justify-center items-center">
                        {loading == false && (
                          <Search className="text-gray-400 w-4 h-4 ml-2 mr-2" />
                        )}
                        {loading == true && (
                          <Loader className="text-gray-400 w-4 h-4 ml-2 mr-2" />
                        )}
                        <input
                          type="text"
                          placeholder="Search by company name or symbol..."
                          value={text}
                          onChange={(e) => {setText(e.target.value); }}
                          className="w-full py-3 rounded-lg focus:outline-none focus:ring-0 focus:border-transparent"
                        />
                      </div>

                      {loading == true && (
                        <span className="text-sm text-gray-400 mr-2">Loading...</span>
                      )}
                      {searchResults.length == 0 && loading == false && text.length > 0 && (
                        <span className="w-fit text-sm text-gray-400 mr-2 whitespace-nowrap">No results</span>
                      )}
                    </div>
                  </div>

                  {/* <select 
                    value={sectorFilter} 
                    onChange={(e) => setSectorFilter(e.target.value)}
                    className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-linkedin-blue"
                  >
                    <option value="all">All Sectors</option>
                    <option value="Technology">Technology</option>
                    <option value="Consumer Cyclical">Consumer Cyclical</option>
                    <option value="Healthcare">Healthcare</option>
                    <option value="Financial">Financial</option>
                  </select> */}
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
                  {searchResults.map((stock) => (
                    <div key={stock.id} className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center justify-between">
                          <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
                            <img src={stock.image} />
                          </div>
                          <div className="ml-3">
                            <h3 className="font-bold text-lg text-gray-900">{stock.company_name}</h3>
                            {/* <p className="text-sm text-gray-600">{stock.name}</p> */}
                          </div>
                        </div>
                      </div>
                      
                      <div className="space-y-2">
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">CIK:</span>
                          <span className="font-medium">{stock.cik}</span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Symbol:</span>
                          <span className="font-medium">{stock.symbol}</span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Sector:</span>
                          <span className="font-medium">{stock.sector}</span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Industry:</span>
                          <span className="font-medium">{stock.industry}</span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Success Rate:</span>
                          <span className={`font-medium ${
                            stock.success_rate >= 85 ? 'text-green-600' : 
                            stock.success_rate >= 70 ? 'text-yellow-600' : 'text-red-600'
                          }`}>
                            {stock.success_rate}%
                          </span>
                        </div>
                      </div>
                      
                      <button className="w-full mt-4 bg-linkedin-blue text-white py-2 px-4 rounded-lg hover:bg-linkedin-blue-dark transition-colors" onClick={() => openCompanyPage(stock)}>
                        View Details
                      </button>
                    </div>
                  ))}
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchPage;